import { Controller } from 'stimulus';
import { useDispatch, useWindowResize } from 'stimulus-use';
import Swiper, { Pagination, Mousewheel } from 'swiper'; 
import { gsap } from 'gsap';
import { getBreakpointValue, isMinBreakpoint } from './../tailwindhelpers';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindconfig from '../../../tailwind.config';

Swiper.use([Pagination, Mousewheel]);

const fullConfig = resolveConfig(tailwindconfig);

export default class extends Controller {
  static targets = [ 'container', 'wrapper', 'pagination', 'toggle', 'content', 'title', 'info', 'imageWrapper', 'image', 'infoContainer' ];

  initialize() {
    this.swiper = new Swiper(this.containerTarget, {
      init: false,
      centeredSlides: true,
      spaceBetween: 15,
      pagination: {
        el: this.paginationTarget,
        type: 'fraction',
      },
      loop: true,
    }) 
  }

  connect() {
    useDispatch(this);
    useWindowResize(this);
    //document.dispatchEvent(new Event('ps-connected'));

    this.infoIsOpen = false;

    this.swiper.init();

    setTimeout(() => {
      this.generateContentAnimation();
    }, 0);

  } 

  windowResize({ height, width }) { 
    this.dispatch('request-fh'); 

    setTimeout(() => {
      this.swiper.update();
      this.writeWrapperHeights(height, width);
      this.writeContentWidth(height, width); 
    }, 0);

    if (isMinBreakpoint(width, 'md')) {
      this.disableTouch();
    } else {
      this.enableTouch();
    }
  }

  generateContentAnimation() {
    if (window.innerWidth >= getBreakpointValue('md')) { 
      //this.contentTarget.style.left = `calc(100% - ${this.infoTarget.getBoundingClientRect().width + 4}px)`;
      //const width = `calc(${window.innerWidth} - ${this.infoTarget.getBoundingClientRect().width * 2}px)`;
      //const left = `calc(${window.innerWidth} + ${this.infoTarget.getBoundingClientRect().width * 2}px)`;
      //this.contentTarget.style.width =  width;
      this.contentAnimation = gsap.timeline({
        paused: true,
        defaults: {
          duration: .3,
          ease: 'none',
        }
      })
      .addLabel('start')
      .to(this.contentTarget, {
        duration: 0,
        autoAlpha: 1,
      }, 'start')
      .to(this.contentTarget, {
        x:  '-100%',
      }, 'start')
      .to(this.paginationTarget, {
        duration: .1,
        autoAlpha: 0,
      }, 'start'); 
    } else {
      this.contentAnimation = gsap.timeline({
        paused: true,
        defaults: {
          duration: .3,
          ease: 'none',
        }
      })
      .addLabel('start')
      .to(this.contentTarget, {
        duration: 0,
        autoAlpha: 1,
      }, 'start')
      .to(this.contentTarget, {
        left: 0,
      }, 'start') 
      .to(this.paginationTarget, {
        duration: .1,
        autoAlpha: 0,
      }, 'start'); 

    }
  }

  writeContentWidth(height, width) {
    if (isMinBreakpoint(width, 'md')) {
      const infoWidth = this.infoTarget.getBoundingClientRect().width;
      this.contentTarget.style.minWidth = `${infoWidth}px`;
      this.contentTarget.style.width = `${window.innerWidth - infoWidth * 2}px`; 
    }
  }

  writeWrapperHeights(height, width) {
    if ( isMinBreakpoint(width, 'md')) {
      this.imageWrapperTargets.forEach((el) => {
        el.style.height = `100%`;
      })

      this.contentTarget.style.height = `100%`; 
    } else { 
      const containerHeight = this.element.getBoundingClientRect().height;
      const infoHeight = this.infoTarget.getBoundingClientRect().height;
      const titleHeight = this.titleTarget.getBoundingClientRect().height;
      const newHeight = containerHeight - infoHeight - titleHeight;

      this.imageWrapperTargets.forEach((el) => {
        el.style.height = `${newHeight}px`;
      })

      this.contentTarget.style.height = `${newHeight}px`;
    }
  } 

  openInfo() {
    this.contentAnimation.play();
    this.swiper.allowSlideNext = false;
    this.swiper.allowSlidePrev = false;
    this.swiper.allowTouchMove = false;
    window.dispatchEvent(new Event('infoopen'))
    this.infoIsOpen = true;
  }

  closeInfo() {
    this.contentAnimation.reverse();
    this.swiper.allowSlideNext = true;
    this.swiper.allowSlidePrev = true;
    this.swiper.allowTouchMove = true;
    window.dispatchEvent(new Event('infoclose'))
    this.infoIsOpen = false;
  }

  toggleInfo() {
    this.infoIsOpen ? this.closeInfo() : this.openInfo();
  }

  next() {
    this.swiper.slideNext();
  }

  prev() {
    this.swiper.slidePrev();
  }

  disableTouch() {
      //this.swiper.allowSlideNext = false;
      //this.swiper.allowSlidePrev = false;
      this.swiper.allowTouchMove = false;
  }

  enableTouch() {
      //this.swiper.allowSlideNext = true;
      //this.swiper.allowSlidePrev = true;
      this.swiper.allowTouchMove = true;
  }

}
